<template>
  <el-dialog
    :title="$t('distributionMode.deleteTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('distributionMode.deleteConfirm') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleDelete">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteDistributionMode } from '@/api/goods/distributionModeApi'

export default {
  name: 'DeleteDistributionMode',
  data() {
    return {
      dialogVisible: false,
      currentRow: {}
    }
  },
  methods: {
    open(row) {
      this.currentRow = Object.assign({}, row)
      this.dialogVisible = true
    },
    handleClose() {
      this.currentRow = {}
    },
    async handleDelete() {
      this.currentRow.shopId = getShopId()
      
      try {
        await deleteDistributionMode(this.currentRow)
        this.$message.success(this.$t('distributionMode.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除派送方式失败:', error)
      }
    }
  }
}
</script>